import { render, staticRenderFns } from "./DisputeResolution.vue?vue&type=template&id=ffeef8b4&scoped=true"
import script from "./DisputeResolution.vue?vue&type=script&lang=js"
export * from "./DisputeResolution.vue?vue&type=script&lang=js"
import style0 from "./DisputeResolution.vue?vue&type=style&index=0&id=ffeef8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffeef8b4",
  null
  
)

export default component.exports